const detectBrowser = require('a_common-folder/utils/detectBrowser');
import {RESOLUTION} from 'a_common-folder/constants';

export const getScreenShareStream = () => {
    return new Promise(async (res, rej) => {
        try{
            const displayStream = await navigator.mediaDevices.getDisplayMedia(window.constraints = {video: true, audio: true})
            const [videoTrack] = displayStream.getVideoTracks();
            // const audioStream = await navigator.mediaDevices.getUserMedia({audio: true})
            // const [audioTrack] = audioStream.getAudioTracks();

            const stream = new MediaStream([videoTrack]);

            res(stream);
        }catch (e){
            rej(e);
        }
    })

}

export const canShareScreen = () => {
    return navigator.mediaDevices.getDisplayMedia;
}

export const getUserMedia = () => {
    return new Promise(async (res, rej) => {
        try{
            const is_iOS = detectBrowser.is_iOS;
            const is_Safari = detectBrowser.is_Safari;
            const resolution = RESOLUTION;

            const stream = await navigator.mediaDevices.getUserMedia(window.constraints = {
                video: is_iOS ? resolution.ios : is_Safari ? resolution.safari : resolution.default,
                audio: true
            })

            res(stream);
        }catch (e){
            rej(e);
        }
    })

}
